// extracted by mini-css-extract-plugin
export default {"table":"styles_table__0+Z02","dark":"styles_dark__wPQaM"};